import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
  JANETH_CANO_TOP_SRC,
} from '../brandAssets';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Hablemos de Todo: conversaciones para crecer en lo personal y profesional
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio de Janeth Cano en TNO Network para hablar de relaciones, liderazgo, bienestar y desarrollo humano con invitados expertos.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Hablemos de Todo?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/hablemosdetodo"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/hablemosdetodo
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Talk show de entrevistas y reflexión en TNO Network: temas que impactan la vida diaria, la carrera y la
          salud emocional de la audiencia. Disponible en formato On-Demand y clips para redes del ecosistema TNO.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={4}>
            <Box display="flex" justifyContent="center" flexDirection="column" gap={2}>
              <Box
                component="img"
                src={JANETH_CANO_TOP_SRC}
                alt="Janeth Cano - Retrato"
                sx={{
                  width: { xs: 240, sm: 280, md: 320 },
                  height: { xs: 280, sm: 320, md: 360 },
                  objectFit: 'cover',
                  objectPosition: 'center',
                  borderRadius: 2,
                  boxShadow: 3,
                  mx: 'auto',
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: JANETH CANO
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              Comunicadora y entrevistadora · conversaciones con propósito · crecimiento personal y profesional.
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'} sx={{ mb: 2 }}>
              <strong>Janeth Cano</strong> conduce <strong>Hablemos de Todo</strong>, un formato de entrevistas y
              conversación directa sobre liderazgo, relaciones, comunicación, salud emocional y herramientas prácticas
              para tomar mejores decisiones. Una vitrina ideal para marcas que buscan afinidad y confianza.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Ideal para marcas de bienestar, educación, salud, servicios profesionales, consumo y estilo de vida que
              quieren conectar con audiencias adultas activas en digital.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
